"use client";
//#region packages/@mantine/core/src/components/FloatingIndicator/FloatingIndicator.module.css
var FloatingIndicator_module_default = { "root": "m_96b553a6" };
//#endregion
export { FloatingIndicator_module_default as default };

//# sourceMappingURL=FloatingIndicator.module.mjs.map